import React from 'react';
import { Tabs, Tab, Box } from '@mui/material';

const ProfileTabBar = ({ activeTab, onTabChange, sessionCount, projectCount, starredCount }) => {
  // Build list of tabs that have items
  const tabs = [];
  if (sessionCount > 0) tabs.push({ label: `Sessions (${sessionCount})`, value: 'sessions' });
  if (projectCount > 0) tabs.push({ label: `Projects (${projectCount})`, value: 'projects' });
  if (starredCount > 0) tabs.push({ label: `Starred (${starredCount})`, value: 'starred' });

  // Only render when 2+ tabs have items
  if (tabs.length < 2) return null;

  return (
    <Box sx={{ mb: 2.5 }}>
      <Tabs
        value={activeTab}
        onChange={(_, val) => onTabChange(val)}
        sx={{
          minHeight: 40,
          '& .MuiTab-root': {
            textTransform: 'none',
            fontWeight: 600,
            fontSize: '0.9rem',
            minHeight: 40,
            py: 1
          }
        }}
      >
        {tabs.map((t) => (
          <Tab key={t.value} label={t.label} value={t.value} />
        ))}
      </Tabs>
    </Box>
  );
};

export default ProfileTabBar;
